import { Component } from '@angular/core';
import { ContactModel } from 'src/app/core/models/contact/contact.model';


@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
})

/**
 * Contacts Component
 */

export class ContactsComponent {

  // bread crumb items
  breadCrumbItems!: Array<{}>;
  contactModel: ContactModel = new ContactModel(); // model is here so we can preform things outside of list on this page with the model if needed. 

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: 'Contacts' },
      { label: 'Contact Management', active: true }
    ];
  }
}
